import { createSelector } from 'reselect'

import {
  addonsForMeetingIntelligencePlan,
} from 'features/billing/modals/plan_selection_modal/config/addons'

import {
  subscriptionPlanSelector,
  currentTierSelector,
  hasMIaddonSelector,
  miAddonSelector
} from '../selectors'


const featureRootSelector = ({ billing }) => billing

const quickPurchaseSelector = createSelector(
  featureRootSelector,
  ({ quickPurchase }) => quickPurchase
)

const desiredAddonsSelector = createSelector(
  quickPurchaseSelector,
  ({ desiredAddons }) => desiredAddons
)

const desiredPlanSelector = createSelector(
  quickPurchaseSelector,
  ({ desiredPlan }) => desiredPlan
)

export const isQuickPurchaseSelector = createSelector(
  desiredAddonsSelector,
  desiredPlanSelector,
  (addons, plan) => addons.length > 0 || !!plan
)

const eligiblePlansSelector = createSelector(
  desiredAddonsSelector,
  (addons) => addons[0].plans
)

const eligibleTierAndFrequnecySelector = createSelector(
  eligiblePlansSelector,
  (eligiblePlans) => eligiblePlans[0].split('-')
)

const eligibleFrequencySelector = createSelector(
  eligibleTierAndFrequnecySelector,
  (eligibleTierAndFrequnecy) => eligibleTierAndFrequnecy[1]
)

export const needsTierUpgradeSelector = createSelector(
  eligiblePlansSelector,
  subscriptionPlanSelector,
  (eligiblePlans, planId) => !eligiblePlans.includes(planId)
)

export const eligibleTierSelector = createSelector(
  eligibleTierAndFrequnecySelector,
  (eligibleTierAndFrequnecy) => eligibleTierAndFrequnecy[0]
)

export const addonsRequestParamsSelector = createSelector(
  needsTierUpgradeSelector,
  eligibleTierSelector,
  eligibleFrequencySelector,
  desiredAddonsSelector,
  currentTierSelector,
  hasMIaddonSelector,
  miAddonSelector,
  (needsTierUpgrade, tierId, frequency, desiredAddons, currentTier, hasMiAddon, miAddon) => {
    let addons = desiredAddons

    // Standard to Teams, or
    // Standard+ to Teams+
    if (needsTierUpgrade) {
      if (hasMiAddon && miAddon) {
        const newMiAddons = addonsForMeetingIntelligencePlan({
          tier: tierId,
          billingPeriod: frequency.replace('monthly', 'month').replace('yearly', 'year')
        })
        addons = [
          ...addons,
          { sku_id: newMiAddons[0], base_sku: 'meeting-intelligence' }
        ]
      }

      return { tier_id: tierId, frequency, addons }
    }

    // Teams to Teams with SSO, or
    // Teams+ to Teams+ with SSO

    if (hasMiAddon && miAddon) {
      addons = [
        ...addons,
        { sku_id: miAddon.sku_id, base_sku: 'meeting-intelligence' }
      ]
    }

    return { addons }
  }
)
